// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sps-intercom-dropdown{position:relative;width:100%}.sps-intercom-dropdown-link{position:relative}.sps-intercom-dropdown-wrapper{padding:0rem 0.9375rem;position:relative}.sps-intercom-dropdown__unread-message-counter{background:#1f282c;font-weight:bold;color:#fff;position:absolute;top:0.3125rem;right:0.3125rem;border-radius:0.1875rem;padding:0.125rem 0.3125rem;line-height:1;white-space:nowrap;display:block;font-size:0.75rem;text-align:center;height:auto}\n", ""]);
// Exports
module.exports = exports;
